<template>
    <div class="">
        <div class="page-wrapper">
            <div class="page-header-title">
                <div class="page-header-title-label">选择课程</div>
                <div>
                    <span class="page-header-date-label">学习计划时长：</span>
                    <span class="page-header-date-time">{{ ableSelectInfo.studyTotalTime }}分钟</span>
                </div>
            </div>
            <div class="page-content-wrapper">
                <div class="page-item-wrapper">
                    <div class="page-content-title-wrapper">
                        <div class="page-content-title">可选课程</div>
                    </div>
                    <div class="transfer-counter">
                        共{{ ableSelectInfo.courseTotalCount }}门/{{ ableSelectInfo.courseTotalTime }}分钟
                    </div>
                    <div class="transfer-container">
                        <div class="transfer-header">
                            <div class="transfer-all-check">
                                <el-checkbox v-model="ableAllChecked" @change="handleAbleTotalSelect">全选</el-checkbox>
                            </div>

                        </div>
                        <div class="transfer-content-container">
                            <div class="transfer-content-wrapper">
                                <div class="transfer-content-search-wrapper">
                                    <el-input placeholder="搜索课程标题" v-model="ableSearchVal" @change="ableSearchChange">
                                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                    </el-input>
                                </div>
                                <div class="transfer-content">
                                    <div v-for="(item, key) in tableData" :key="key">
                                        <div class="transfer-item">
                                            <div class="transfer-item-checkbox-wrapper">
                                                <div class="transfer-checkbox">
                                                    <el-checkbox v-model="item.checked"
                                                        @change="handleAbleSelect(item)"></el-checkbox>
                                                </div>
                                                <div class="transfer-checkbox-label" @click="handleAbleSelect(item)">
                                                    {{ item.courseName }}
                                                </div>
                                            </div>
                                            <div class="transfer-item-record-wrapper">
                                                <div class="transfer-record-label">录制</div>
                                                <div class="transfer-record-line"></div>
                                                <div class="transfer-record-value">{{ item.courseTime }}分钟</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="transfer-btn">
                    <div :class="`transfer-btn-item ${isAfterStartTime && editFlag ? 'not-click' : ''}`"
                        @click="handleRemoveClass">
                        <i class="el-icon-arrow-left"></i>
                        移除课程
                    </div>
                    <div :class="`transfer-btn-item transfer-btn-bottom ${isAfterStartTime && editFlag ? 'not-click' : ''}`"
                        @click="handleAddClass">
                        添加课程
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="page-item-wrapper">
                    <div class="page-item-wrapper">
                        <div class="page-content-title-wrapper">
                            <div class="page-content-title">已选课程</div>
                            <div class="selected-header-wrapper">
                                <img src="@/assets/img/wh.png" alt="" class="selected-header-img">
                                <div class="selected-header-label">需求进度：</div>
                                <div class="selected-header-count">
                                    <!-- <span v-show="selectedInfo.requiredProgress === -1">
                                        {{'——'}}
                                    </span> -->
                                    <el-input-number v-model="selectedInfo.requiredProgress" label="" :min="0"
                                        id="rebateInput" @change="changeProgress" :disabled="isAfterStartTime && editFlag"
                                        size="mini"></el-input-number>
                                </div>
                            </div>
                        </div>
                        <div class="transfer-counter">
                            共{{ selectedInfo.courseTotalCount }}门/{{ selectedInfo.courseTotalTime }}分钟
                        </div>
                        <div class="transfer-container">
                            <div class="transfer-header">
                                <div class="transfer-all-check">
                                    <el-checkbox v-model="selectedAllChecked" @change="handleTotalSelected">全选</el-checkbox>
                                </div>

                            </div>
                            <div class="transfer-content-container">
                                <div class="transfer-content-wrapper">
                                    <div class="transfer-content-search-wrapper">
                                        <!-- <el-input
                                            placeholder="搜索课程标题"
                                            v-model="selectedSearchVal" @change="selectedSearchChange">
                                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                        </el-input> -->
                                    </div>
                                    <div class="transfer-content">
                                        <div v-for="(item, key) in selectedData" :key="key">
                                            <div class="transfer-item">
                                                <div class="transfer-item-checkbox-wrapper">
                                                    <div class="transfer-checkbox">
                                                        <el-checkbox v-model="item.checked"
                                                            @change="handleSelected(item)"></el-checkbox>
                                                    </div>
                                                    <div class="transfer-checkbox-label" @click="handleSelected(item)">
                                                        {{ item.courseName }}
                                                    </div>
                                                </div>
                                                <div class="transfer-item-record-container">
                                                    <div class="transfer-item-record-wrapper">
                                                        <div class="transfer-record-label">录制</div>
                                                        <div class="transfer-record-line"></div>
                                                        <div class="transfer-record-value">{{ item.courseTime }}分钟</div>
                                                    </div>
                                                    <div class="selected-header-count selected-count-item">
                                                        <el-input-number v-model="item.requiredProgress" :min="1" label=""
                                                            :disabled="isAfterStartTime && editFlag" size="mini"
                                                            @change="progressChange"></el-input-number>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-btn-wrapper">
                <div class="page-btn deal-btn btn-gap" @click="handleLast">上一步</div>
                <div class="page-btn deal-btn btn-gap" @click="handleNext">下一步</div>
                <div class="page-btn deal-btn btn-gap" @click="skip">跳过</div>
                <div class="page-btn deal-btn btn-gap" @click="handleSubmit">完成</div>
                <div class="page-btn cancel-btn btn-gap" @click="handleBack">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ableSelectedCourse,
    hasSelectedCourse,
    ableSelectCourseInfo,
    selectedCourseInfo,
    addPlanCourse, skipPlanCourse
} from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            dept: '',
            token: '',
            ableAllChecked: false,
            tableData: [],
            totalTableRecords: 0,
            ableSearchVal: '',
            ableSelectInfo: {},
            selectedSearchVal: '',
            selectedAllChecked: false,
            selectedInfo: {
                requiredProgress: 0,
            },
            selectedData: [],
            isAfterStartTime: this.$route.query.isAfterStartTime ? JSON.parse(this.$route.query.isAfterStartTime) : false, // 是否为开始时间后进来编辑
            editFlag: false, // 编辑标识
        }
    },
    mounted() {
        scrollTo(0, 0);
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        var planInfo = window.localStorage.getItem('plan');
        if (planInfo && JSON.parse(planInfo).mode === 'edit') {
            this.editFlag = true
        }
        this.addUnit()
        this.getTableData();
        this.getSelectedCourse();
        this.getTableInfo();
        this.getSelectedInfo();
    },
    watch: {
        selectedData(val) {
            if (val) {
                this.progressChange()
            }
        }
    },
    methods: {

        //跳过
        skip() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));

            skipPlanCourse({
                "planId": planInfo.id,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.$emit('step', 'add-test');
                    localStorage.setItem('skip', true)
                }
            })

        },
        //可选课程操作
        handleAbleSelect(row) {
            var tableData = this.tableData;
            for (var i = 0; i < tableData.length; i++) {
                var item = tableData[i];
                if (item.courseId == row.courseId) {
                    this.tableData[i]['checked'] = row.checked;
                }
                if (i == tableData.length - 1) {
                    this.justifyAbleSelect();
                }
            }
        },
        justifyAbleSelect() {
            var tableData = this.tableData;
            var num = 0;
            if (tableData.length > 0) {
                for (var i = 0; i < tableData.length; i++) {
                    var item = tableData[i];
                    if (item.checked) {
                        num++;
                    }
                    if (i == tableData.length - 1) {
                        if (num == tableData.length) {
                            this.ableAllChecked = true;
                        } else {
                            this.ableAllChecked = false;
                        }
                    }
                }
            } else {
                this.ableAllChecked = false;
            }
        },
        handleAbleTotalSelect() {
            var ableAllChecked = this.ableAllChecked;
            var tableData = this.tableData;
            if (ableAllChecked) {
                this.tableData = tableData.map(function (item) {
                    item['checked'] = true;
                    return item;
                });
            } else {
                this.tableData = tableData.map(function (item) {
                    item['checked'] = false;
                    return item;
                });
            }
        },
        //已选课程造作
        handleSelected(row) {
            var selectedData = this.selectedData;
            for (var i = 0; i < selectedData.length; i++) {
                var item = selectedData[i];
                if (item.courseId == row.courseId) {
                    this.selectedData[i]['checked'] = row.checked;
                }
                if (i == selectedData.length - 1) {
                    this.justifySelected();
                }
            }
        },
        justifySelected() {
            var selectedData = this.selectedData;
            var num = 0;
            if (selectedData.length > 0) {
                for (var i = 0; i < selectedData.length; i++) {
                    var item = selectedData[i];
                    if (item.checked) {
                        num++;
                    }
                    if (i == selectedData.length - 1) {
                        if (num == selectedData.length) {
                            this.selectedAllChecked = true;
                        } else {
                            this.selectedAllChecked = false;
                        }
                    }
                }
            } else {
                this.selectedAllChecked = false;
            }
        },
        handleTotalSelected() {
            var selectedAllChecked = this.selectedAllChecked;
            var selectedData = this.selectedData;
            if (selectedAllChecked) {
                this.selectedData = selectedData.map(function (item) {
                    item['checked'] = true;
                    return item;
                });
            } else {
                this.selectedData = selectedData.map(function (item) {
                    item['checked'] = false;
                    return item;
                });
            }
        },
        //获取可选课程
        getTableData() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            ableSelectedCourse({
                "deptId": this.dept,
                "keyword": this.ableSearchVal,
                "pageNum": 1,
                "pageSize": 10000,
                "planId": planInfo.id
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var newArr = [];
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        this.$set(item, 'checked', false)
                        newArr.push(item);
                        if (i == data.length - 1) {
                            this.tableData = newArr;
                        }
                    }
                    this.totalTableRecords = res.data.totalRecords;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        ableSearchChange() {
            this.getTableData();
        },
        //获取已选课程
        getSelectedCourse() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            hasSelectedCourse({
                "deptId": this.dept,
                "keyword": this.selectedSearchVal,
                "pageNum": 1,
                "pageSize": 10000,
                "planId": planInfo.id
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var newArr = [];
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        item["checked"] = false;
                        newArr.push(item);
                        if (i == data.length - 1) {
                            this.selectedData = newArr;
                            this.justifySelected();
                        }
                    }
                    this.totalSelectedRecords = res.data.totalRecords;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        selectedSearchChange() {
            this.getSelectedCourse();
        },
        getTableInfo() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            ableSelectCourseInfo(planInfo.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.ableSelectInfo = res.data;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        getSelectedInfo() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            selectedCourseInfo(planInfo.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.selectedInfo = res.data;
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        //添加课程
        handleAddClass() {
            var tableData = this.tableData;
            if (tableData.length == 0) {
                this.$message.error('暂无可选课程');
            } else {
                this.ableSelectCountChecked();
            }
        },
        ableSelectCountChecked() {
            var tableData = this.tableData;
            var newArr = this.selectedData;
            var newList = [];
            var num = 0;
            for (var i = 0; i < tableData.length; i++) {
                var item = tableData[i];
                if (item.checked) {
                    //已选中课程
                    num++;
                    item['checked'] = false;
                    newArr.push(item);
                } else {
                    newList.push(item);
                }
                if (i == tableData.length - 1) {
                    if (num > 0) {
                        this.tableData = newList;
                        this.selectedData = newArr;
                        this.setTableInfo();
                        this.setSelectedInfo();
                        //检测是否全选
                        this.justifyAbleSelect();
                        this.justifySelected();
                    } else {
                        this.$message.error('请至少选择一门课程');
                    }
                }
            }
        },
        setSelectedInfo() {
            var selectedData = this.selectedData;
            var timeSum = 0;
            this.selectedInfo["courseTotalTime"] = timeSum;
            for (var i = 0; i < selectedData.length; i++) {
                var item = selectedData[i];
                timeSum += item.courseTime;
                if (i == selectedData.length - 1) {
                    this.selectedInfo["courseTotalTime"] = timeSum;
                }
            }
            this.selectedInfo["courseTotalCount"] = selectedData.length;
        },
        setTableInfo() {
            var tableData = this.tableData;
            var timeSum = 0;
            this.ableSelectInfo["courseTotalTime"] = timeSum;
            for (var i = 0; i < tableData.length; i++) {
                var item = tableData[i];
                timeSum += item.courseTime;
                if (i == tableData.length - 1) {
                    this.ableSelectInfo["courseTotalTime"] = timeSum;
                }
            }
            this.ableSelectInfo["courseTotalCount"] = tableData.length;
        },
        //移除课程
        handleRemoveClass() {
            var selectedData = this.selectedData;
            if (selectedData.length > 0) {
                var newArr = [];
                var newList = this.tableData;
                var num = 0;
                for (var i = 0; i < selectedData.length; i++) {
                    var item = selectedData[i];
                    if (item.checked) {
                        num++;
                        newList.unshift(item);
                    } else {
                        newArr.push(item);
                    }
                    if (i == selectedData.length - 1) {
                        if (num > 0) {
                            this.tableData = newList;
                            this.selectedData = newArr;
                            this.setTableInfo();
                            this.setSelectedInfo();
                            //检测是否全选
                            this.justifyAbleSelect();
                            this.justifySelected();
                        } else {
                            this.$message.error('请至少选择一门已选课程');
                        }
                    }
                }
            } else {
                this.$message.error('暂无已选课程');
            }
        },
        //点击完成按钮
        handleSubmit() {
            localStorage.setItem('skip', false)
            var selectedData = this.selectedData;
            var newArr = [];
            if (selectedData && selectedData.length === 0) {
                this.$message.error('请至少选择一门已选课程');
            }
            if (this.isAfterStartTime && this.editFlag) {
                this.handleBack();
            } else {
                if (selectedData.length > 0) {
                    for (var i = 0; i < selectedData.length; i++) {
                        var item = selectedData[i];
                        // if(item.checked){
                        var newRow = {
                            courseId: item.courseId,
                            requiredProgress: item.requiredProgress
                        }
                        newArr.push(newRow);
                        // }
                        if (i == selectedData.length - 1) {
                            if (newArr.length > 0) {
                                if (this.selectedInfo.requiredProgress > 0 || this.selectedInfo.requiredProgress === 0) {
                                    var _this = this;
                                    this.requestAddCourse(newArr, function () {
                                        _this.$message({
                                            message: '添加课程成功',
                                            type: 'success'
                                        });

                                        _this.handleBack()
                                    });
                                } else {
                                    this.$message.error('需求进度不能为0');
                                }
                            } else {
                                this.$message.error('请至少选择一门已选课程');
                            }
                        }
                    }
                } else {
                    this.$message.error('请至少选择一门已选课程');
                }
            }
        },
        requestAddCourse(arr, callback) {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            addPlanCourse({
                "courseList": arr,
                "deptId": this.dept,
                "planId": planInfo.id,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    callback();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                //  console.log(err);
            });
        },
        handleLast() {
            localStorage.setItem('skip', false)
            this.$emit('step', 'basic-info');
        },
        handleNext() {
            localStorage.setItem('skip', false)
            var selectedData = this.selectedData;
            var newArr = [];
            if (selectedData && selectedData.length === 0) {
                this.$message.error('请至少选择一门已选课程');
            }
            if (this.isAfterStartTime && this.editFlag) {
                this.$emit('step', 'add-test');
            } else {
                for (var i = 0; i < selectedData.length; i++) {
                    var item = selectedData[i];
                    // if(item.checked){
                    var newRow = {
                        courseId: item.courseId,
                        requiredProgress: item.requiredProgress
                    }
                    newArr.push(newRow);
                    // }
                    if (i == selectedData.length - 1) {
                        if (newArr.length > 0) {
                            if (this.selectedInfo.requiredProgress > 0 || this.selectedInfo.requiredProgress === 0) {
                                var _this = this;
                                this.requestAddCourse(newArr, function () {
                                    var planInfo = JSON.parse(window.localStorage.getItem('plan'));
                                    console.log(planInfo, "planInfo");
                                    _this.$emit('step', 'add-test');
                                });
                            } else {
                                this.$message.error('需求进度不能为0');
                            }
                        } else {
                            this.$message.error('请至少选择一门已选课程');
                        }
                    }
                }
            }
        },
        handleDeal() {
            this.$router.push(`/studyPlan/manage-plan`);
        },
        handleBack() {

            localStorage.setItem('skip', false)
            this.$router.go(-1);
            //  this.$router.push(`/studyPlan/manage-plan`);
        },
        // 需求进度改变
        changeProgress(val) {
            this.selectedData.forEach((item) => {
                this.$set(item, 'requiredProgress', val)
            })
            this.addUnit();
        },
        // 添加需求单位
        addUnit() {
            const span = document.createElement('span');
            const innerspan = document.createElement('span');
            const textspan = document.createElement('span');

            span.setAttribute('class', 'el-input__suffix');
            span.setAttribute('style', 'right:36px !important');
            innerspan.setAttribute('class', 'el-input__suffix-inner');

            span.append(innerspan);
            innerspan.append(textspan);
            textspan.append('%');

            this.$nextTick(() => {
                document.getElementById('rebateInput').lastElementChild.prepend(span);
            });
        },
        // 进度改变
        progressChange() {
            if (this.selectedData && this.selectedData.length !== 0) {
                let requiredProgressArr = this.selectedData.map((item) => {
                    if (item.requiredProgress === 0) {
                        item.requiredProgress = 1
                    }
                    return item.requiredProgress
                })
                // 如果都是相同的进度
                if (new Set(requiredProgressArr).size === 1) {
                    this.selectedInfo.requiredProgress = requiredProgressArr[0] === 0 ? 1 : requiredProgressArr[0]
                } else {
                    this.selectedInfo.requiredProgress = 0
                }
            }
        }
    }
}
</script>

<style scoped>
.page-container {
    display: flex;
}

.page-wrapper {
    flex: 1;
    margin-top: 40px;
}

.page-header-title {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.page-header-title-label {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-header-date-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
}

.page-header-date-time {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
}

.page-content-wrapper {
    display: flex;
    /* justify-content: space-between; */
    margin-top: 30px;
    padding-bottom: 29px;
    border-bottom: 1px solid #F0F0F0;
}

.page-content-title-wrapper {
    display: flex;
    /* justify-content: space-between; */
}

.page-item-wrapper {
    width: 474px;
}

.page-content-title {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.transfer-container {
    width: 100%;
    height: 682px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #CBCBCB;
    margin-top: 16px;
}

.transfer-header {
    width: 100%;
    height: 52px;
    background: #F7F7F8;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
}

.transfer-all-check {
    margin-left: 20px;
}

.transfer-counter {
    margin-right: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.transfer-header>>>.el-checkbox__label {
    font-size: 16px !important;
}

.transfer-content-container {
    width: 100%;
}

.transfer-content-search-wrapper {
    width: 420px;
    margin: 0 auto;
}

.transfer-content-wrapper {
    width: 100%;
    height: 610px;
    padding-top: 19px;
    overflow-x: hidden;
    overflow-y: auto;
}

.scrollbar {
    width: 30px;
    height: 300px;
    margin: 0 auto;
}

.transfer-content-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 1px;
}

.transfer-content-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgb(193, 193, 193);
    background: #535353;
}

.transfer-content-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: #ededed;
}

.transfer-content {
    width: 420px;
    margin: 0 auto;
}

.transfer-item {
    padding-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EAEAEA;
}

.transfer-item-checkbox-wrapper {
    display: flex;
}

.transfer-checkbox {
    position: relative;
    top: 3px;
    margin-right: 10px;
}

.transfer-checkbox-label {
    width: 100%;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #333333;
    cursor: pointer;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    position: relative;
    top: -1px;
}

.transfer-btn {
    height: 682px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0px 20px 0px 20px;
}

.transfer-btn-item {
    width: 122px;
    height: 40px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.not-click {
    pointer-events: none;
    color: #c0c4cc;
    border-color: #c0c4cc;
}

.transfer-btn-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.transfer-btn-bottom {
    margin-top: 40px;
}

.transfer-item-record-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.transfer-item-record-wrapper {
    display: flex;
    margin-left: 24px;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    align-items: center;
}

.selected-count-item {
    position: relative;
    top: 5px;
}

.transfer-record-line {
    width: 1px;
    height: 16px;
    margin-left: 8px;
    margin-right: 8px;
    background: #D7D7D7;
}

.page-btn-wrapper {
    display: flex;
    /* justify-content: end; */
    margin-top: 39px;
    padding-bottom: 50px;
}

.page-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.deal-btn {
    background: #3E63EE;
    color: #FFFFFF;
}

.deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.cancel-btn {
    border: 1px solid #4F79ED;
    color: #4F79ED;
}

.cancel-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff
}

.btn-gap {
    margin-left: 20px;
}

.selected-header-wrapper {
    display: flex;
    align-items: center;
}

.selected-header-img {
    width: 22px;
    height: 22px;
}

.selected-header-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    position: relative;
    top: -2px;
    margin-left: 5px;
}

.selected-header-count>>>.el-input__inner {
    width: 110px !important;
    height: 28px !important;
    border-radius: 14px !important;
    border: 1px solid #3E63EE !important;
    color: #3E63EE !important;
}

.selected-header-count>>>.el-input-number--mini {
    width: 110px !important;
    height: 28px !important;
}

.selected-header-count>>>.el-input-number__decrease {
    background: #fff !important;
    border-top-left-radius: 24px !important;
    border-bottom-left-radius: 24px !important;
    color: #3E63EE !important;
}

.selected-header-count>>>.el-input-number__increase {
    background: #fff !important;
    border-top-right-radius: 24px !important;
    border-bottom-right-radius: 24px !important;
    color: #3E63EE !important;
}

.selected-header-count #rebateInput>>>.el-input__suffix {
    right: 30px;
}
</style>


